export default __webpack_public_path__ + "static/media/Ballroll_00187.3f4a5b07.png";